<template>
    <all-campaigns-base
        companyTypeFilter="city"
        :city="city"
        :initialCategory="initialCategory"
        :initialSubcategory="initialSubcategory"
        :initialTitle="city.name"
        :data="data"
        :paginator="paginator">
    </all-campaigns-base>
</template>

<script>
    import AllCampaignsBase from '@/Pages/AllCampaigns/AllCampaigns';

    export default {
        props: ['initialCategory', 'initialSubcategory', 'city', 'data', 'paginator'],

        components: { AllCampaignsBase },
    }
</script>
